/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class InfraMisConfigurationsTrendListFiltersSortCriteria {
    getFixupPrototypeFunction() { return InfraMisConfigurationsTrendListFiltersSortCriteria.fixupPrototype; }

    static newInstance(model: Partial<InfraMisConfigurationsTrendListFiltersSortCriteria>): InfraMisConfigurationsTrendListFiltersSortCriteria {
        let obj = Object.assign(new InfraMisConfigurationsTrendListFiltersSortCriteria(), model);
        InfraMisConfigurationsTrendListFiltersSortCriteria.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<InfraMisConfigurationsTrendListFiltersSortCriteria>): InfraMisConfigurationsTrendListFiltersSortCriteria {
        if (!model) return null;
        return InfraMisConfigurationsTrendListFiltersSortCriteria.newInstance(<InfraMisConfigurationsTrendListFiltersSortCriteria> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: InfraMisConfigurationsTrendListFiltersSortCriteria) {
        if (!obj) return;

        models.InfraMisConfigurationsTrendListFiltersSortCriteria.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: InfraMisConfigurationsTrendListFiltersSortCriteria): boolean {
        Object.setPrototypeOf(obj, InfraMisConfigurationsTrendListFiltersSortCriteria.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    column: models.InfraMisConfigurationsTrendListFiltersSortColumn;

    ascending: boolean;

}
